import { render, staticRenderFns } from "./MicrosoftLicences.vue?vue&type=template&id=34cefc4a&scoped=true"
import script from "./MicrosoftLicences.vue?vue&type=script&lang=js"
export * from "./MicrosoftLicences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cefc4a",
  null
  
)

export default component.exports